/**
 * 输入过程转换金额字符串
 * 用户输入过程虽然有通过正则表达式做输入格式校验，但允许输入部分特别的字符组合，所以需对这种输入做适当的转换
 * 此方法主要是用在输入过程，某些场景下需要补齐和简化用户输入：如用户开头输入一个0，会自动加一个小数点变成0.
 * @param value
 * @returns
 */
export function parseAmount(value: string) {
  let val = value || '';

  // 1、如果只输入一个0或者点号，转换成0.，一般是用户首次输入时
  if (val === '0' || val === '.') {
    return '0.';
  }
  // 以下均为用户删除操作后出现的情况
  // 2、0开头一个或多个，后面是1-9，那么删除开头的所有0
  val = val.replace(/^0+([1-9]+)(.*)$/, '$1$2');

  // 3、多个0开头，后面是小数点，那么多个0保留1个
  val = val.replace(/^0+(\.)(.*)/, '0$1$2');

  // 4、整数最多5位
  val = val.replace(/^(\d{5})(\d{1,2})\d*$/, '$1.$2');

  return val;
}

/**
 * 金额字符串输入格式判断
 * @param value
 * @returns
 */
export function checkAmountInput(value: string) {
  // 金额数组校验表达式
  // 1、直接输入一个0、点号(.)或者0.  /^0?\.?$/
  // 2、输入最多5整数，可以带2个小数 ^[1-9]([0-9]{0,4})?(\.[0-9]{0,2})?$
  // 前半部分可以输入.、0、0.、0.0、 0.0[1-9]，后半部分输入不超过5位的整数 + 不超过2位的小数点
  const pn = /(^0?(\.[0-9]?[1-9]?)?$)|(^[1-9]([0-9]{0,4})?(\.[0-9]{0,2})?$)/;
  return pn.test(value);
}

